import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_417: DocMigration = {
  maxSchemaVersion: "0.0.417",
  description: "Set titleHidden to true by default for all data tables",
  apply(json: any) {
    for (const id in json.dataTables) {
      const dataTable = json.dataTables[id];
      dataTable.titleHidden = dataTable.titleHidden ?? true;
    }

    return json;
  },
};

export default migration_0_0_417;
